module.exports = __webpack_public_path__ + "img/undset_Portrett1.c488b37e.jpg";